var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"活动专区","left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$router.push('/')}}}),_vm._v(" "),_c('div',_vm._l((_vm.activeList),function(item,index){return _c('router-link',{key:index,attrs:{"to":{
        path: '/activity/activity_detail',
        query: { activityid: item.id },
      }}},[_c('van-image',{attrs:{"width":"100%","src":item.title}})],1)}),1),_vm._v(" "),_c('CommonLoading',{ref:"commonLoader"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f10525e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity.vue
// module id = null
// module chunks = 